import { AUTH_API_PATHS } from '../constants/api'
import { apiRequest } from './client'
import type { ApiAuthTokens, ApiAuthUser, ApiRequestOtpResponse } from './types'

export function requestLoginOtp(phone: string): Promise<ApiRequestOtpResponse> {
  return apiRequest<ApiRequestOtpResponse>(AUTH_API_PATHS.otpRequest, {
    method: 'POST',
    body: { phone },
  })
}

export function verifyLoginOtp(phone: string, code: string): Promise<ApiAuthTokens> {
  return apiRequest<ApiAuthTokens>(AUTH_API_PATHS.otpVerify, {
    method: 'POST',
    body: { phone, code },
  })
}

export function loginWithEmail(email: string, password: string): Promise<ApiAuthTokens> {
  return apiRequest<ApiAuthTokens>(AUTH_API_PATHS.login, {
    method: 'POST',
    body: { email, password },
  })
}

export function registerWithEmail(
  email: string,
  password: string,
  name?: string,
): Promise<ApiAuthTokens> {
  return apiRequest<ApiAuthTokens>(AUTH_API_PATHS.register, {
    method: 'POST',
    body: { email, password, ...(name ? { name } : {}) },
  })
}

export function loginWithGoogle(idToken: string): Promise<ApiAuthTokens> {
  return apiRequest<ApiAuthTokens>(AUTH_API_PATHS.google, {
    method: 'POST',
    body: { idToken },
  })
}

export function refreshAuthTokens(refreshToken: string): Promise<ApiAuthTokens> {
  return apiRequest<ApiAuthTokens>(AUTH_API_PATHS.refresh, {
    method: 'POST',
    body: { refreshToken },
    skipRefresh: true,
  })
}

export function logoutAuth(refreshToken?: string): Promise<{ ok: true }> {
  return apiRequest<{ ok: true }>(AUTH_API_PATHS.logout, {
    method: 'POST',
    auth: true,
    body: refreshToken ? { refreshToken } : {},
  })
}

export function fetchAuthMe(): Promise<ApiAuthUser> {
  return apiRequest<ApiAuthUser>(AUTH_API_PATHS.me, {
    method: 'GET',
    auth: true,
  })
}

export function updateAuthProfile(
  updates: { name?: string; phone?: string } | string,
): Promise<ApiAuthUser> {
  const body = typeof updates === 'string' ? { name: updates } : updates
  return apiRequest<ApiAuthUser>(AUTH_API_PATHS.me, {
    method: 'PATCH',
    auth: true,
    body,
  })
}

export function requestPhoneChangeOtp(phone: string): Promise<ApiRequestOtpResponse> {
  return apiRequest<ApiRequestOtpResponse>(AUTH_API_PATHS.mePhoneOtp, {
    method: 'POST',
    auth: true,
    body: { phone },
  })
}

export function verifyPhoneChange(phone: string, code: string): Promise<ApiAuthUser> {
  return apiRequest<ApiAuthUser>(AUTH_API_PATHS.mePhoneVerify, {
    method: 'POST',
    auth: true,
    body: { phone, code },
  })
}
